import { Button, Select, Input, Segmented } from 'antd';
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

const { Option } = Select;

const FilterPanel = ({
  onClose,
  columns,
  filters,
  setFilters,
  logic,
  setLogic,
  onApply,
  onClear,
}) => {
  const [draft, setDraft] = useState({
    columnId: '',
    columnName: '',
    type: '',
    options: [],
    operation: '',
    value: '',
  });

  // const createFilter = () => {
  //   if (!draft.columnId || !draft.operation) return;

  //   setFilters([...filters, draft]);
  //   setDraft({
  //     columnId: '',
  //     columnName: '',
  //     type: '',
  //     options: [],
  //     operation: '',
  //     value: '',
  //   });
  // };

  const createFilter = () => {
    if (!draft.columnId || !draft.operation) return;

    const updatedFilters = [...filters, draft];

    setFilters(updatedFilters);

    onApply({ filters: updatedFilters, logic });

    setDraft({
      columnId: '',
      columnName: '',
      type: '',
      options: [],
      operation: '',
      value: '',
    });
  };

  const removeFilter = (index) => {
    const updatedFilters = filters.filter((_, i) => i !== index);

    setFilters(updatedFilters);

    onApply({ filters: updatedFilters, logic });
  };

  const handleColumnChange = (colId) => {
    const selectedCol = columns.find((c) => c.id === colId);

    setDraft({
      columnId: selectedCol.id,
      columnName: selectedCol.name,
      type: selectedCol.type,
      options: selectedCol.options || [],
      operation: '',
      value: '',
    });
  };

  const getOperations = (type) => {
    switch (type) {
      case 'text':
        return ['contains', 'equals', 'not_equals'];
      case 'number':
        return ['greater_than', 'less_than', 'equals'];
      case 'status':
        return ['is', 'isNot'];
      case 'assignee':
        return ['is', 'not_equals', 'empty'];
      default:
        return ['contains'];
    }
  };

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 16px',
          borderBottom: '1px solid #eee',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontWeight: 600 }}>Filter</span>
        </div>
        <CloseOutlined onClick={onClose} style={{ cursor: 'pointer' }} />
      </div>

      <div style={{ padding: 16, flex: 1, overflowY: 'auto' }}>
        <div style={{ marginBottom: 12, color: '#555' }}>
          In this view, show entries where...
        </div>

        <Segmented
          options={['AND', 'OR']}
          value={logic}
          onChange={(val) => {
            setLogic(val);
            onApply({ filters, logic: val });
          }}
          style={{ marginBottom: 16 }}
        />

        <div
          style={{
            border: '1px solid #eee',
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
          }}
        >
          <div style={{ fontWeight: 500, marginBottom: 10 }}>Create filter</div>

          <Select
            placeholder="Select column..."
            value={draft.columnId || undefined}
            onChange={handleColumnChange}
            style={{ width: '100%', marginBottom: 10 }}
          >
            {columns.map((col) => (
              <Option key={col.id} value={col.id}>
                {col.name}
              </Option>
            ))}
          </Select>

          <Select
            placeholder="Select operation..."
            value={draft.operation || undefined}
            style={{ width: '100%', marginBottom: 10 }}
            onChange={(val) => setDraft({ ...draft, operation: val })}
          >
            {getOperations(draft.type).map((op) => (
              <Option key={op} value={op}>
                {op}
              </Option>
            ))}
          </Select>

          {/* {draft.operation === 'contains' && (
            <Input
              placeholder="Enter value..."
              value={draft.value}
              onChange={(e) => setDraft({ ...draft, value: e.target.value })}
              style={{ marginBottom: 10 }}
            />
          )}

          {draft.type === 'status' && (
            <Select
              value={draft.value}
              onChange={(val) => setDraft({ ...draft, value: val })}
            >
              {draft.options.map((opt) => (
                <Option key={opt} value={opt}>
                  {opt}
                </Option>
              ))}
            </Select>
          )}

          {draft.type === 'text' && (
            <Input
              value={draft.value}
              onChange={(e) => setDraft({ ...draft, value: e.target.value })}
            />
          )}

          {draft.type === 'number' && (
            <Input
              type="number"
              value={draft.value}
              onChange={(e) => setDraft({ ...draft, value: e.target.value })}
            />
          )} */}

          {/* VALUE INPUT */}
          {draft.operation &&
            draft.operation !== 'is_empty' &&
            draft.operation !== 'is_not_empty' && (
              <>
                {draft.type === 'status' ? (
                  <Select
                    placeholder="Select value..."
                    value={draft.value}
                    onChange={(val) => setDraft({ ...draft, value: val })}
                    style={{ width: '100%', marginBottom: 12 }}
                  >
                    {draft.options.map((opt) => (
                      <Option key={opt} value={opt}>
                        {opt}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <Input
                    type={draft.type === 'number' ? 'number' : 'text'}
                    placeholder="Enter value..."
                    value={draft.value}
                    onChange={(e) =>
                      setDraft({ ...draft, value: e.target.value })
                    }
                    style={{ marginBottom: 12 }}
                  />
                )}
              </>
            )}

          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            <Button
              type="primary"
              disabled={!draft.columnId || !draft.operation}
              onClick={createFilter}
              style={{ background: '#7a3db8', border: 'none', color: 'white' }}
            >
              Create
            </Button>
            <Button
              onClick={() => setDraft({ column: '', operation: '', value: '' })}
            >
              Cancel
            </Button>
          </div>
        </div>

        {filters.map((f, i) => (
          <div
            key={i}
            style={{
              border: '1px solid #eee',
              borderRadius: 8,
              padding: 12,
              marginBottom: 12,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <div style={{ fontWeight: 500 }}>{f.columnName}</div>

              <div style={{ fontSize: 13, color: '#666' }}>
                {f.operation} {f.value && `"${f.value}"`}
              </div>
            </div>

            <DeleteOutlined
              onClick={() => removeFilter(i)}
              style={{ cursor: 'pointer', color: '#999' }}
            />
          </div>
        ))}
      </div>

      <div
        style={{
          padding: 16,
          borderTop: '1px solid #eee',
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
        }}
      >
        <Button
          type="primary"
          block
          style={{ background: '#7a3db8', border: 'none', width: 100 }}
          onClick={() => {
            onApply({ filters, logic });
            onClose();
          }}
        >
          Save changes
        </Button>

        <Button
          block
          onClick={onClear}
        >
          Clear all
        </Button>
      </div>
    </div>
  );
};

export default FilterPanel;
